import { NgModule } from '@angular/core';
import { OkmodalPage } from './okmodal';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [
    OkmodalPage
  ],
  imports: [
    IonicModule
  ],
  entryComponents: [
    OkmodalPage
  ]
})
export class OkmodalPageModule {}
